export default __webpack_public_path__ + "static/media/screen1.3a8ea9f0.png";